import Main from "../../components/main";

export default function Stats() {
    return (
      <Main title="Stats">
        <h2>Stats</h2>
      </Main>
    );
  }